import merge from 'deepmerge'
import { useFormatting } from "./chart_formatting"

export default class DecorationConfigurator {
  constructor(source) {
    useFormatting(this)
    this.source = source
  }

  get config() {
    let cfg = {}

    if (this.shouldColorNegatives || this.shouldColorByYear || this.shouldColorPoints) {
      cfg.data ??= {}
      cfg.data.color = this.colorize
    }

    return cfg
  }

  get msConfig() {
    return this.source.ms
  }

  get shouldColorNegatives() {
    return Boolean(this.msConfig?.color_negatives) &&
      this.msConfig.color_negatives === Object(this.msConfig.color_negatives)
  }

  get negConfig() {
    return this.msConfig.color_negatives
  }

  get negColorables() {
    return Object.keys(this.negConfig)
  }

  get shouldColorByYear() {
    return Boolean(this.msConfig?.colors_by_year) &&
      this.msConfig.colors_by_year === Object(this.msConfig.colors_by_year)
  }

  get colorsByYear() {
    return this.msConfig.colors_by_year
  }

  get shouldColorPoints() {
    return Boolean(this.msConfig?.point_colors) &&
      this.msConfig.point_colors === Object(this.msConfig.point_colors)
  }

  get pointColors() {
    return this.msConfig.point_colors
  }

  colorize = (color, d) => {
    const pointColor = this.colorizePoint(d)
    if (pointColor) return pointColor

    const yearColor = this.colorizeByYear(d)
    if (yearColor) return yearColor

    return this.colorizeNegatives(color, d)
  }

  colorizePoint = (d) => {
    if (!this.shouldColorPoints || !d.id || !d.x) return

    return this.pointColors[d.id]
  }

  colorizeByYear = (d) => {
    if (!this.shouldColorByYear || !d.id || !d.x) return

    const year = new Date(d.x).getUTCFullYear()
    return this.colorsByYear[d.id]?.[year]
  }

  colorizeNegatives = (color, d) => {
    if (!this.shouldColorNegatives) return color

    // bail if we can't get the data category or value
    if (!Boolean(d.id) || !Boolean(d.value)) return color

    if (this.negColorables.includes(d.id)) {
      return (d.value < 0) ? this.negConfig[d.id] : color
    } else {
      return color
    }
  }
}


export { DecorationConfigurator }
